module.exports = __webpack_public_path__ + "static/alexwork8-63b028acad78db4566faa503faf571db.jpg";